import ExportHeader from '@Components/common/CommonExport/ExportHeader';
import ExportRoundedContainer from '@Components/common/CommonExport/ExportRoundedContainer';
import hasErrorBoundary from '@Components/common/hasErrorBoundary';
import Partners from '@Components/ProvincialProfile/ChartSection/Partners';
import { deletePdfSection } from '@Store/actions/pdfExport';
import { useDispatch } from 'react-redux';

const ReportPartner = () => {
  const dispatch = useDispatch();
  return (
    <ExportRoundedContainer className="report-chart naxatw-relative">
      <ExportHeader
        onHandleDelete={() =>
          dispatch(
            deletePdfSection({
              page: 'palikaDetails',
              section: 'partnerChart',
            }),
          )
        }
        className="!naxatw-right-[5px] !naxatw-top-[5px]"
      />
      <Partners isExport />
    </ExportRoundedContainer>
  );
};

export default hasErrorBoundary(ReportPartner);
